import { render } from "./homeComponent.vue?vue&type=template&id=47c167c4&scoped=true"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"

import "./homeComponent.vue?vue&type=style&index=0&id=47c167c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c167c4"]])

export default __exports__